module.exports = __webpack_public_path__ + "src/assets/img/door_right_color.e05bcc71.svg";